import React, { Component } from 'react';
import { Button } from '@blueprintjs/core';
import EasyTable from '../../EasyTable';
import EditableDetail from '../EditableDetail';
import EditableAdditionalDetail from '../EditableAdditionalDetail';
import InputText from '../../../blueprintWrappers/InputText';

class PMBP extends Component {

	render() {
		const p = this.props;
		return (
			<div className={"PMBP page"}>

				<div className={"topheader"}>
					<div className={"topheader_left"}>

					</div>
					<div className={"topheader_right"}>

					</div>
				</div>

				<div className="content">
					<div className="content_center">
						<div className={"content_header"}>

							<div className={"content_header_helper"}>
								<div onClick={p.goBack}><span className="icon">&#x25C0;</span>{"Back"}</div>
							</div>
						</div>

						<div className={"content_panel"}>
							{this.notifications()}
							{this.details()}
							{this.additionalDetails()}
						</div>

						<div className={"content_panel"}>
							{this.projects()}
						</div>
						<div className={"content_panel"}>
							{this.contacts()}
						</div>
					</div>
				</div>

			</div>
		);
	}

	notifications = () => {
		const p = this.props;
		const { saved } = p.state;

		return <div>
			{saved ?
				null
				:
				<div style={{ backgroundColor: 'red' }}>
					This Business Parter has unsaved details
					<Button onClick={p.toggleSaved}>
						Save
				</Button>
				</div>
			}
		</div>
	}

	details = () => {
		const p = this.props;
		const { currentItem } = p.state;

		return (
			<div className={"PMBPDetails"}>
				<EditableDetail
					property={"companyName"}
					value={currentItem.companyName}
					onChange={p.onChange}
					onSave={p.onChange}
				/>
				<EditableDetail
					small
					property={"addressOne"}
					value={currentItem.addressOne}
					onChange={p.onChange}
					onSave={p.onChange}
				/>
				<EditableDetail
					small
					property={"addressTwo"}
					value={currentItem.addressTwo}
					onChange={p.onChange}
					onSave={p.onChange}
				/>
				<EditableDetail
					small
					property={"description"}
					value={currentItem.description}
					onChange={p.onChange}
					onSave={p.onChange}
				/>
			</div>
		)
	}

	additionalDetails = () => {
		const p = this.props;
		const { newCommentLine } = p.state;
		const { storedCommentLines } = p.reduxData;

		if (storedCommentLines.length === 0) {
			return (
				<div className={"AdditionalDetails"}>

					<InputText
						onChange={p.onChangeAdditionalDetail}
						value={newCommentLine.comment}
						returnObj={{ attr: "comment" }}
						placeholder={"Add a new detail"}
					/>

					<Button onClick={() => p.addAdditionalDetail()} >
						+ Add Additional Detail
					</Button>
				</div>
			)
		}

		return (
			<div className={"AdditionalDetails"}>
				{storedCommentLines.map((detail, index) => {
					return <EditableAdditionalDetail
						small
						value={detail}
						index={index}
						key={detail.uniqueID + '_editable_' + index}
						updateComment={p.updateComment}
					/>
				})}

				<InputText
					onChange={p.onChangeAdditionalDetail}
					value={newCommentLine.comment}
					returnObj={{ attr: "comment" }}
					placeholder={"Add a new detail"}
				/>
				<Button onClick={() => p.addAdditionalDetail()} >
					+ Add Additional Detail
				</Button>

			</div>
		)
	}

	projects = () => {
		const p = this.props;
		const { filteredProjects } = p.state;

		return (
			<div className={"PMBPProjects"}>
				<EasyTable
					tableName={"Projects"}
					selectValue={'uniqueID'}
					headers={['Project', 'Total Phases', 'Most Recent Phase', 'Project Staff', 'Status']}
					show={['display', 'phases', 'phase', 'assigned', 'status']}
					data={filteredProjects}
					onClick={p.selectProject}
					customColumns={['phases', 'assigned']}
					renderCustomColumn={this.renderCustomColumn}
				>
					<Button onClick={p.addProject} >
						+ Add New Project
					</Button>
				</EasyTable>

			</div>
		)
	}

	renderCustomColumn = (property, row, i) => {
		switch (property) {
			case 'phases':
				return <td key={i}>{row[property].length}</td>
			case 'assigned':
				let usernames = [];
				row[property].forEach(element => {
					let loc = this.props.reduxData.storedUsers.findIndex(indexOfUser)

					if (loc > -1) {
						usernames.push(this.props.reduxData.storedUsers[loc].firstName + ' ' + this.props.reduxData.storedUsers[loc].lastName.substring(0, 1))
					}

					function indexOfUser(usr) {
						return usr.uniqueID === element;
					}
				});
				return <td key={i}>{usernames.join(", ")}</td>
			default:
				return <td key={i}>{row[property]}</td>
		}
	}

	contacts = () => {
		const p = this.props;
		const { assignedContacts } = p.state;
		return (
			<div className={"PMBPContacts"}>
				<EasyTable
					tableName={"Contacts"}
					selectValue={'uniqueID'}
					headers={['Name', 'Role', 'Email', 'Phone', 'Notes']}
					show={['firstName', 'role', 'email', 'phone1', 'notes']}
					data={assignedContacts}
					onClick={p.editContact}
					customColumns={['firstName']}
					renderCustomColumn={this.renderCustomColumnContacts}
				>
					<Button onClick={p.saveBPContact} >
						+ Add New Contact
					</Button>
				</EasyTable>
			</div>
		)
	}

	renderCustomColumnContacts = (property, row, i) => {
		switch (property) {
			case 'firstName':
				let fullName = row.firstName + ' ' + row.lastName;//.substring(0, 1);
				return <td key={i}>{fullName}</td>
			default:
				return <td key={i}>{row[property]}</td>
		}
	}

}

export default PMBP;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/BP/PMBP.js